import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import { memo } from "react";

/* eslint-disable react/prop-types */

function Fields2({ formData }) {
  const { formField2, values, errors, touched } = formData;
  const { taxAlternatePayerName, taxAlternatePayerId} =
    formField2;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAlternatePayerName.name}
            label={taxAlternatePayerName.label}
            value={values.taxAlternatePayerName}
            error={errors.taxAlternatePayerName && touched.taxAlternatePayerName}
            success={
              values.taxAlternatePayerName?.toString().length > 0 && !errors.taxAlternatePayerName
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAlternatePayerId.name}
            label={taxAlternatePayerId.label}
            value={values.taxAlternatePayerId}
            error={errors.taxAlternatePayerId && touched.taxAlternatePayerId}
            success={
              values.taxAlternatePayerId?.toString().length > 0 && !errors.taxAlternatePayerId
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(Fields2);
